import dayjs from "dayjs";
import {balanceOfFundsFunds} from "../../../../app/components/client/application-stages/_common/funding/BalanceOfFunds";
import {MortgageTypes} from "../../../../models";

export default function (mortgage, config) {
    const mapSource = [
        {
            "name": "aip-conditions",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "balance-of-funds",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "gifts",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "htb",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "loan-required",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "product-type",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "property-value",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "rate",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "solicitor-details",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "term",
            "type": "TEXT",
            "page": 1
        },
        {
            "name": "source-of-wealth",
            "type": "TEXT",
            "page": 2
        },
        {
            "name": "ability-to-repay",
            "type": "CHECK",
            "page": 3
        },
        {
            "name": "account-no",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "applicant-1",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "applicant-2",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "date",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "intermediary-name-1",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "intermediary-name-1",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "intermediary-name-2",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "intermediary-name-2",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "kev-sign",
            "type": "SIGNKEVIN",
            "page": 3
        },
        {
            "name": "list-of-docs-1",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "list-of-docs-2",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "proof-of-id",
            "type": "CHECK",
            "page": 3
        },
        {
            "name": "signer-name",
            "type": "TEXT",
            "page": 3
        }
    ]
    const map={}
    const ask=[]
    const errors=[]
    const bof = balanceOfFundsFunds(mortgage)

    // Price
    if (!mortgage.property.propertyPrice){
        ask.push({
            label: 'Property Price',
            name: 'property-price',
            type: 'TEXT',
            group: 'Mortgage'
        })
        if (config.hasOwnProperty('property-price')){
            map['property-value'] = config['property-price']
        }
        else{
            errors.push('No Property Price')
        }
    }
    else{
        map['property-value'] = mortgage.property.propertyPrice.toEuro(0)
    }

    //Loan Required
    if (!(mortgage.activeSubmission.finalLoan || mortgage.activeSubmission.provisionalLoan )){
        ask.push({
            label: 'Loan Required',
            name: 'loan-required',
            type: 'TEXT',
            group: 'Mortgage'
        })
        if (config.hasOwnProperty('loan-required')){
            map['loan-required'] = config['loan-required']
        }
        else{
            errors.push('No Loan Required')
        }
    }
    else{
        map['loan-required'] = (mortgage.activeSubmission.finalLoan || mortgage.activeSubmission.provisionalLoan).toEuro(0)
    }

    //Term
    if (!(mortgage.activeSubmission.finalTerm || mortgage.activeSubmission.aipTerm || mortgage.activeSubmission.provisionalTerm)){
        ask.push({
            label: 'Term (years)',
            name: 'term',
            type: 'TEXT',
            group: 'Mortgage'
        })
        if (config.hasOwnProperty('term')){
            map['term'] = config['term']
        }
        else{
            errors.push('No Term')
        }
    }
    else{
        map['term'] = (mortgage.activeSubmission.finalTerm || mortgage.activeSubmission.aipTerm || mortgage.activeSubmission.provisionalTerm) + ' years'
    }

    //Rate
    if (!(mortgage.activeSubmission.finalRate  || mortgage.activeSubmission.provisionalRate)){
        ask.push({
            label: 'Rate (%)',
            name: 'rate',
            type: 'TEXT',
            group: 'Mortgage'
        })
        if (config.hasOwnProperty('rate')){
            map['rate'] = config['rate'] + '%'
        }
        else{
            errors.push('No Rate')
        }
    }
    else{
        map['rate'] = (mortgage.activeSubmission.finalRate  || mortgage.activeSubmission.provisionalRate) + '%'
    }

    //Product Type
    if (!(mortgage.activeSubmission.finalProduct || mortgage.activeSubmission.provisionalProduct )){
        ask.push({
            label: 'Product Type',
            name: 'product-type',
            type: 'TEXT',
            group: 'Mortgage'
        })
        if (config.hasOwnProperty('product-type')){
            map['product-type'] = config['product-type']
        }
        else{
            errors.push('No Product Type')
        }
    }
    else{
        map['product-type'] =mortgage.activeSubmission.finalProduct || mortgage.activeSubmission.provisionalProduct
    }

    // Gifts

    map['gifts'] = bof.gifts.toEuro(0)
    map['htb'] = bof.helpToBuy.toEuro(0)

    map['balance-of-funds'] = mortgage.mortgageType !== MortgageTypes.REFINANCE ? bof.requiredSavings.toEuro(0) : 0

    //AIP Conditions
    ask.push({
        label: 'AIP Conditions',
        name: 'aip-conditions',
        type: 'TEXTAREA',
        group: 'Mortgage'
    })
    if (config.hasOwnProperty('aip-conditions')){
        map['aip-conditions'] = config['aip-conditions'].split('\n')
    }

    //Solicitor Details
    if (!mortgage.solicitor.firmName){
        ask.push({
            label: 'Solicitor Details',
            name: 'solicitor-details',
            type: 'TEXTAREA',
            group: 'Mortgage'
        })
        if (config.hasOwnProperty('solicitor-details')){
            map['solicitor-details'] = config['solicitor-details'].split('\n')
        }
        else{
            errors.push('No Solicitor Details')
        }
    }
    else{
        map['solicitor-details'] = [mortgage.solicitor.firmName,mortgage.solicitor.firmAddress]
    }

    // Saource of Wealth
    ask.push({
        label: 'Source of Wealth',
        name: 'source-of-wealth',
        type: 'TEXTAREA',
        group: 'Mortgage'
    })
    if (config.hasOwnProperty('source-of-wealth')){
        map['source-of-wealth'] = config['source-of-wealth'].split('\n')
    }

    // Intermediary Names
    map['intermediary-name-1'] = 'Truss Mortgages Ltd t/a Sussd Mortgages'
    map['intermediary-name-2'] = '222 Harolds Cross Road, Dublin 6W'

    map['applicant-1'] = mortgage.applicant1.fullName

    if (mortgage.twoApplicants){
        map['applicant-2'] = mortgage.applicant2.fullName
    }

    if (!mortgage.activeSubmission.mortgageAccountNo){
        ask.push({
            label: 'Mortgage Account No',
            name: 'account-no',
            type: 'TEXT',
            group: 'Mortgage'
        })
        if (config.hasOwnProperty('account-no')){
            map['account-no'] = config['account-no']
        }
        else{
            errors.push('No Mortgage Account No')
        }
    }
    else{
        map['account-no'] = mortgage.activeSubmission.mortgageAccountNo
    }
    map['date'] = dayjs().format('D MMMM YYYY')
    map['kev-sign'] = true
    map['signer-name'] = 'Kevin Coakley'
    map['proof-of-id'] = true
    map['ability-to-repay'] = true
    map['confirm-provided'] = true

    ask.push({
        label: 'Repay Documents Line 1',
        name: 'list-of-docs-1',
        type: 'TEXT',
        group: 'Mortgage'
    })
    ask.push({
        label: 'Repay Documents Line 2',
        name: 'list-of-docs-2',
        type: 'TEXT',
        group: 'Mortgage'
    })
    if (config.hasOwnProperty('list-of-docs-1')){
        map['list-of-docs-1'] = config['list-of-docs-1']
    }
    else{
        errors.push('No Repay Documents Line 1')
    }

    if (config.hasOwnProperty('list-of-docs-2')){
        map['list-of-docs-2'] = config['list-of-docs-2']
    }


    return {sections:[{map, ask, errors}]}



}